var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.46711 4.82881C1.69664 6.03301 1.25 7.46435 1.25 9C1.25 13.2802 4.71979 16.75 9 16.75C10.8669 16.75 12.5796 16.0899 13.9174 14.9904L13.0539 13.7571C11.9625 14.688 10.5469 15.25 9 15.25C5.54822 15.25 2.75 12.4518 2.75 9C2.75 8.83065 2.75674 8.66287 2.76995 8.49693H5.08458L2.81587 5.3269L2.46711 4.82881ZM16.75 9C16.75 10.4839 16.333 11.8703 15.6097 13.0486L14.6493 11.677C14.6496 11.6764 14.6499 11.6758 14.6501 11.6752L12.7765 9.05726H15.2497C15.2499 9.03819 15.25 9.01911 15.25 9C15.25 5.54822 12.4518 2.75 9 2.75C7.50117 2.75 6.12557 3.27759 5.04878 4.1572L4.18647 2.9257C5.50858 1.87659 7.18111 1.25 9 1.25C13.2802 1.25 16.75 4.71979 16.75 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.7c1ba94d6273d1d534b44b7cc02c152d.svg";
export { ForwardRef as ReactComponent };